import { NeueAttachmentRegularIcon, NeueLinkRegularIcon, NeuePdfRegularIcon } from 'src/monet/icons';

export const NeueNodeIcons = {
  pdf: NeuePdfRegularIcon,
  embed: NeueLinkRegularIcon,
  external_link: NeueLinkRegularIcon,
  file: NeueAttachmentRegularIcon,
};
